import React from 'react';
import { Container, Flex, Box } from '@goodrx/matisse';

export const AuthLayout: React.FC = ({ children }) => {
  return (
    <Container>
      <Flex flexDirection={{ _: 'column', md: 'row' }} alignItems={{ _: 'center', md: 'flex-start' }}>
        <Box maxWidth={384} mx={{ _: 0, sm: 'auto' }}>
          {children}
        </Box>
      </Flex>
    </Container>
  );
};
